import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-tag-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})

export class SelectComponent implements OnInit {

  tags: any = [];
  @Input() selected_tags: any = [];
  @Input() url = 'clients';
  @Input() url_base = 'tags';

  @Input() title = "Select Tags";
  @Input() source_header = "Avaliable Tags";
  @Input() target_header = "Assigned Tags";
  @Input() name = "Tag";

  @Input() local_only = false;
  @Input() show_level = false;
  @Input() current_tags: any = [];

  roles: any = [];

  add_tag = {
    title: '',
    colour: '#90ee90',
    level: 0,
    description: ''
  }


  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  // Creating posts to the tags endpoints, which need tags_create (or statuses_create for the *_internal_status
  // tables) - same rule as the API. Anything else this picker is used for (e.g. groups) is still admin only.
  get can_create(): boolean {
    if (this.url_base === 'tags' && this.url === 'time_and_billing') return this.globalService.Can('time_tags_create');
    if (this.url_base === 'tags') return this.globalService.Can((this.url || '').endsWith('_internal_status') ? 'statuses_create' : 'tags_create');
    if (this.url_base === 'groups') return this.globalService.Can('groups_create');
    return !!this.globalService.GetCurrentUser()?.is_admin;
  }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = null;
    if(!this.local_only) {
      data = await this.apiService.get(`${this.url_base}/${this.url}`);
      this.tags = data.data;
    } else {
      this.tags = this.current_tags;
    }
    console.log(this.tags);
    if(this.tags === null) return;
    var tag_title = this.add_tag.title;
    this.tags.forEach(tag => {
      console.log(tag_title);
      if(tag.title === tag_title) this.selected_tags.push(tag);
    });
    this.selected_tags.forEach(tag => {
      var index = this.tags.findIndex(function(item, i){return (item.guid === tag.guid)});
      if(index >= 0)
        this.tags.splice(index,1);
    });

    console.log(this.selected_tags);
  }

  async Update() {
    this.modalController.dismiss(this.selected_tags);
  }
  async Cancel() {
    this.modalController.dismiss(null);
  }

  async CreateTag() {
    if(this.local_only) {
      let new_tag = {
        guid: this.globalService.createGUID(),
        title: this.add_tag.title,
        description: this.add_tag.description,
        colour: this.add_tag.colour,
        level: this.add_tag.level
      };
      this.current_tags = [...this.current_tags, new_tag];
      console.log("Current Tags: " + JSON.stringify(this.current_tags));
      await this.GetData();
    }
    else{
      let data: any = await this.apiService.post(`${this.url_base}/${this.url}`,this.add_tag);
      this.globalService.presentToastMessage(data.message,data.success);
      await this.GetData();
    }
    
    this.add_tag.title = '';
    this.add_tag.description = '';
    this.add_tag.level = 0;
  }

}

